import styled from '@emotion/styled'
import React from 'react'
import { useSelector } from 'react-redux'

import { Loader } from 'packages/common'
import { text } from 'packages/styles'
import {
  DateFormat,
  createDateString,
  format,
} from 'packages/utils/dateHelpers'

import { getCoverageByDate } from 'app/fieldapp/store/coverage/selectors'
import { ApplicationState } from 'app/fieldapp/store/store'

import { CrossCoverageDrawerContainer } from '../../CrossCoverageDrawer'
import { DayScheduleTimeline } from './DayScheduleTimeline'
import {
  TimelineEntry,
  createTimelineEntry,
} from './DayScheduleTimeline/DayScheduleTimeline.utils'

const St = {
  Container: styled.div`
    position: relative;
    min-height: 150px;
  `,
  Date: styled.div`
    ${text.headingCardAlt};
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
  `,
}

export enum ScheduleDateDetailTestIds {
  container = 'ScheduleDateDetail__container',
}

export type ScheduleDateDetailProps = {
  date: Date
  loading: boolean
}

export const ScheduleDateDetail: React.FC<ScheduleDateDetailProps> = React.memo(
  ({ date, loading }) => {
    const coverageEntries = useSelector((state: ApplicationState) =>
      getCoverageByDate(state, createDateString(date)),
    )

    const timelineEntries: TimelineEntry[] = React.useMemo(() => {
      return coverageEntries.map(createTimelineEntry)
    }, [coverageEntries])

    return (
      <St.Container data-testid={ScheduleDateDetailTestIds.container}>
        {loading && <Loader />}
        <St.Date>
          <span>{format(date, DateFormat.DayNameAndDate)}</span>
          <CrossCoverageDrawerContainer />
        </St.Date>
        {!loading && (
          <>
            {!!timelineEntries.length && (
              <DayScheduleTimeline entries={timelineEntries} />
            )}
          </>
        )}
      </St.Container>
    )
  },
)
